import type { FixtureMeta } from '../../../../../functions/tests/eval/phase1/types'

export interface ConsistencyCheck {
  ok: boolean
  issues: string[]
}

/**
 * Verifies a fixture's `expected` block is internally consistent. Catches the
 * common mistake of editing one count/array without updating the others.
 */
export function checkConsistency(meta: FixtureMeta): ConsistencyCheck {
  const issues: string[] = []
  const e = meta.expected
  if (e.turnSpeakers.length !== e.turnCount) {
    issues.push(
      `turnSpeakers has ${e.turnSpeakers.length} entries but turnCount is ${e.turnCount}`
    )
  }
  if (e.turnMessages.length !== e.turnCount) {
    issues.push(
      `turnMessages has ${e.turnMessages.length} entries but turnCount is ${e.turnCount}`
    )
  }
  const uniqueSpeakers = new Set(e.turnSpeakers)
  if (uniqueSpeakers.size !== e.speakerCount) {
    issues.push(
      `speakerCount is ${e.speakerCount} but turnSpeakers has ${uniqueSpeakers.size} unique values`
    )
  }
  const meInTurns = e.turnSpeakers.includes('me')
  if (e.userPresent !== meInTurns) {
    issues.push(
      `userPresent=${e.userPresent} but "me" ${meInTurns ? 'is' : 'is not'} in turnSpeakers`
    )
  }
  return { ok: issues.length === 0, issues }
}
